import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Search, Compass, Video, TrendingUp } from "lucide-react";
import { PROCESS_STEPS } from "../data/mock";
import Reveal from "./Reveal";

const ICONS = [Search, Compass, Video, TrendingUp];

const SolutionSection = () => {
  return (
    <section className="py-24 md:py-36 bg-white relative overflow-hidden">
      <div className="max-w-[1300px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-neutral-100 border border-black/5 text-xs uppercase tracking-[0.2em] font-semibold text-neutral-700">
            So arbeiten wir
          </span>
          <h2 className="font-display font-extrabold text-4xl md:text-6xl lg:text-7xl tracking-[-0.03em] leading-[1.02] mt-6 text-neutral-950">
            Aus Reichweite werden{" "}
            <span className="bg-gradient-to-r from-pink-500 via-orange-500 to-purple-500 bg-clip-text text-transparent">
              Anfragen.
            </span>
          </h2>
          <p className="mt-6 text-lg md:text-xl text-neutral-600 leading-relaxed">
            Vier klare Schritte. Kein Aktionismus, keine generischen Posts –
            sondern ein System, das messbar wirkt.
          </p>
        </div>

        {/* Timeline / Process */}
        <div className="mt-16 relative">
          {/* Connecting line on desktop */}
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-[2px] bg-gradient-to-r from-pink-500 via-orange-500 to-purple-500 opacity-30" />

          <div className="grid lg:grid-cols-4 gap-6 lg:gap-5 relative">
            {PROCESS_STEPS.map((step, idx) => {
              const Icon = ICONS[idx] || Search;
              return (
                <Reveal key={idx} delay={idx * 100}>
                  <div
                    className="group relative bg-neutral-50 hover:bg-neutral-950 transition-all duration-500 rounded-3xl p-7 lg:p-8 border border-black/5 hover:-translate-y-1 hover:shadow-[0_30px_60px_-20px_rgba(0,0,0,0.25)]"
                  >
                    {/* Step number circle on top */}
                    <div className="flex items-center gap-4 mb-6">
                      <div className="shrink-0 w-12 h-12 rounded-full bg-white border-2 border-pink-500 group-hover:bg-gradient-to-br group-hover:from-pink-500 group-hover:via-orange-500 group-hover:to-purple-500 group-hover:border-transparent flex items-center justify-center font-display font-extrabold text-pink-500 group-hover:text-white transition-all duration-500 relative z-10">
                        {step.step}
                      </div>
                      <Icon
                        size={24}
                        className="text-neutral-400 group-hover:text-pink-300 transition-colors duration-500"
                      />
                    </div>

                    <h3 className="font-display font-extrabold text-xl tracking-tight text-neutral-950 group-hover:text-white transition-colors duration-500">
                      {step.title}
                    </h3>
                    <p className="mt-3 text-sm text-neutral-600 group-hover:text-neutral-300 leading-relaxed transition-colors duration-500">
                      {step.text}
                    </p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>

        <div className="mt-12 flex justify-center">
          <Link
            to="/leistungen"
            className="group inline-flex items-center gap-3 text-sm font-bold text-neutral-950 uppercase tracking-[0.12em] border-b-2 border-neutral-950 pb-1 hover:border-pink-500 hover:text-pink-500 transition-colors"
          >
            Vollständige Leistungen ansehen
            <ArrowRight
              size={16}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
